export default __webpack_public_path__ + "static/media/delivery23green.3049ed11.svg";